import { setTerms } from './helpers';

export const setCoworkingOfferType = setTerms('coworking_offer_type');
